var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    {
      staticClass: "yealink-panel-main",
      class: _vm.embedded ? "" : "ma-5",
      attrs: { flat: "" },
    },
    [
      _c(
        "v-card-text",
        { class: _vm.embedded ? "pa-3" : "pa-0" },
        [
          _vm.loading
            ? _c(
                "div",
                {
                  staticClass:
                    "d-flex flex-column justify-center align-center py-8",
                },
                [
                  _c("v-progress-circular", {
                    attrs: { indeterminate: "", color: "cyan" },
                  }),
                  _c("span", { staticClass: "mt-3 text--secondary" }, [
                    _vm._v(_vm._s(_vm.$t("loading")) + "..."),
                  ]),
                ],
                1
              )
            : _vm.error && !_vm.noSiteFound
            ? _c(
                "v-alert",
                {
                  staticClass: "mb-0",
                  attrs: { type: "error", outlined: "", dense: "" },
                },
                [_vm._v(" " + _vm._s(_vm.error) + " ")]
              )
            : _vm.noSiteFound
            ? _c(
                "div",
                { staticClass: "no-site-state" },
                [
                  _c(
                    "v-icon",
                    { attrs: { size: "64", color: "grey lighten-1" } },
                    [_vm._v("mdi-domain-off")]
                  ),
                  _c("span", { staticClass: "no-site-text" }, [
                    _vm._v(_vm._s(_vm.$t("yealink-no-site-found"))),
                  ]),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "primary", loading: _vm.creatingSite },
                      on: { click: _vm.createSite },
                    },
                    [
                      _c("v-icon", { attrs: { left: "" } }, [
                        _vm._v("mdi-plus"),
                      ]),
                      _vm._v(" " + _vm._s(_vm.$t("yealink-create-site")) + " "),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm.data
            ? _c("div", { staticClass: "yealink-content" }, [
                _c(
                  "div",
                  { staticClass: "site-panel" },
                  [
                    _c("div", { staticClass: "site-panel-header" }, [
                      _c("div", { staticClass: "site-panel-left" }, [
                        _c("div", { staticClass: "site-panel-info" }, [
                          _c(
                            "div",
                            { staticClass: "site-panel-name-row" },
                            [
                              _c(
                                "v-icon",
                                {
                                  staticClass: "mr-1",
                                  attrs: { size: "16", color: "#5a6577" },
                                },
                                [_vm._v("mdi-domain")]
                              ),
                              _c("span", { staticClass: "site-panel-name" }, [
                                _vm._v(_vm._s(_vm.data.site?.name || "-")),
                              ]),
                              _c("span", { staticClass: "site-panel-id" }, [
                                _vm._v("#" + _vm._s(_vm.data.site?.id || "-")),
                              ]),
                              _c(
                                "v-btn",
                                {
                                  staticClass: "change-site-btn",
                                  attrs: { icon: "", "x-small": "" },
                                  on: { click: _vm.openSiteSelectionDialog },
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: {
                                        "x-small": "",
                                        color: "#8a94a6",
                                      },
                                    },
                                    [_vm._v("mdi-swap-horizontal")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c("div", { staticClass: "site-panel-metrics" }, [
                            _c("span", { staticClass: "metric-badge" }, [
                              _c("strong", [
                                _vm._v(_vm._s(_vm.data.total || 0)),
                              ]),
                              _vm._v(
                                " " + _vm._s(_vm.$t("yealink-devices")) + " "
                              ),
                            ]),
                            _c("span", { staticClass: "metric-sep" }, [
                              _vm._v("·"),
                            ]),
                            _c(
                              "span",
                              { staticClass: "metric-badge metric-online" },
                              [
                                _c("span", { staticClass: "metric-dot" }),
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.onlineCount) +
                                    " " +
                                    _vm._s(_vm.$t("yealink-online")) +
                                    " "
                                ),
                              ]
                            ),
                            _c(
                              "span",
                              { staticClass: "metric-badge metric-offline" },
                              [
                                _c("span", { staticClass: "metric-dot" }),
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.offlineCount) +
                                    " " +
                                    _vm._s(_vm.$t("yealink-offline")) +
                                    " "
                                ),
                              ]
                            ),
                            _c(
                              "span",
                              { staticClass: "metric-badge metric-pending" },
                              [
                                _c("span", { staticClass: "metric-dot" }),
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.pendingCount) +
                                    " " +
                                    _vm._s(_vm.$t("yealink-pending")) +
                                    " "
                                ),
                              ]
                            ),
                            _c(
                              "span",
                              { staticClass: "metric-badge metric-registered" },
                              [
                                _c("span", { staticClass: "metric-dot" }),
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.registeredCount) +
                                    " " +
                                    _vm._s(_vm.$t("yealink-registered")) +
                                    " "
                                ),
                              ]
                            ),
                            _c(
                              "span",
                              {
                                staticClass: "metric-badge metric-unregistered",
                              },
                              [
                                _c("span", { staticClass: "metric-dot" }),
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.unregisteredCount) +
                                    " " +
                                    _vm._s(_vm.$t("yealink-unregistered")) +
                                    " "
                                ),
                              ]
                            ),
                            _c(
                              "span",
                              { staticClass: "metric-badge metric-dnd" },
                              [
                                _c("span", { staticClass: "metric-dot" }),
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.dndCount) +
                                    " " +
                                    _vm._s(_vm.$t("yealink-status-dnd")) +
                                    " "
                                ),
                              ]
                            ),
                          ]),
                        ]),
                      ]),
                    ]),
                    _c("yealink-network-toolbox", {
                      ref: "networkToolbox",
                      attrs: { "site-id": _vm.selectedSiteId?.id || null },
                      on: {
                        "scan-update": _vm.onNetworkScanUpdate,
                        scanning: (val) => (_vm.networkScanning = val),
                        rebooted: function ($event) {
                          return _vm.fetchDevices({ silent: true })
                        },
                        "reboot-device": _vm.onToolboxRebootDevice,
                      },
                    }),
                    _c(
                      "div",
                      { staticClass: "devices-toolbar" },
                      [
                        _c("v-text-field", {
                          staticClass: "search-field",
                          attrs: {
                            dense: "",
                            "hide-details": "",
                            outlined: "",
                            clearable: "",
                            placeholder: _vm.$t("search"),
                            "prepend-inner-icon": "mdi-magnify",
                          },
                          model: {
                            value: _vm.searchQuery,
                            callback: function ($$v) {
                              _vm.searchQuery = $$v
                            },
                            expression: "searchQuery",
                          },
                        }),
                        _c(
                          "v-btn",
                          {
                            staticClass: "expand-all-btn hidden-xs-only",
                            attrs: { outlined: "" },
                            on: { click: _vm.toggleAllDevices },
                          },
                          [
                            _c("v-icon", { attrs: { small: "", left: "" } }, [
                              _vm._v(
                                _vm._s(
                                  _vm.hasAnyExpanded
                                    ? "mdi-unfold-less-horizontal"
                                    : "mdi-unfold-more-horizontal"
                                )
                              ),
                            ]),
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.hasAnyExpanded
                                    ? _vm.$t("yealink-collapse-all")
                                    : _vm.$t("yealink-expand-all")
                                ) +
                                " "
                            ),
                          ],
                          1
                        ),
                        _c(
                          "v-btn",
                          {
                            staticClass:
                              "action-icon-btn expand-icon-btn hidden-sm-and-up",
                            attrs: { icon: "", small: "" },
                            on: { click: _vm.toggleAllDevices },
                          },
                          [
                            _c("v-icon", { attrs: { small: "" } }, [
                              _vm._v(
                                _vm._s(
                                  _vm.hasAnyExpanded
                                    ? "mdi-unfold-less-horizontal"
                                    : "mdi-unfold-more-horizontal"
                                )
                              ),
                            ]),
                          ],
                          1
                        ),
                        _c(
                          "v-btn",
                          {
                            staticClass: "add-device-btn hidden-xs-only",
                            attrs: { color: "primary" },
                            on: { click: _vm.openAddDeviceDialog },
                          },
                          [
                            _c("v-icon", { attrs: { small: "", left: "" } }, [
                              _vm._v("mdi-plus"),
                            ]),
                            _vm._v(
                              " " + _vm._s(_vm.$t("yealink-add-device")) + " "
                            ),
                          ],
                          1
                        ),
                        _c(
                          "v-btn",
                          {
                            staticClass:
                              "action-icon-btn add-icon-btn hidden-sm-and-up",
                            attrs: { icon: "", small: "" },
                            on: { click: _vm.openAddDeviceDialog },
                          },
                          [
                            _c("v-icon", { attrs: { small: "" } }, [
                              _vm._v("mdi-plus"),
                            ]),
                          ],
                          1
                        ),
                        _c(
                          "v-btn",
                          {
                            staticClass: "import-devices-btn hidden-xs-only",
                            attrs: { color: "secondary" },
                            on: { click: _vm.openImportDevicesDialog },
                          },
                          [
                            _c("v-icon", { attrs: { small: "", left: "" } }, [
                              _vm._v("mdi-file-upload"),
                            ]),
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("yealink-import-devices")) +
                                " "
                            ),
                          ],
                          1
                        ),
                        _c(
                          "v-btn",
                          {
                            staticClass:
                              "action-icon-btn import-icon-btn hidden-sm-and-up",
                            attrs: { icon: "", small: "" },
                            on: { click: _vm.openImportDevicesDialog },
                          },
                          [
                            _c("v-icon", { attrs: { small: "" } }, [
                              _vm._v("mdi-file-upload"),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "devices-section" },
                  [
                    !_vm.filteredDevices.length
                      ? _c(
                          "v-alert",
                          { attrs: { type: "info", outlined: "", dense: "" } },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.$t("yealink-no-devices")) + " "
                            ),
                          ]
                        )
                      : _c(
                          "div",
                          { staticClass: "devices-list" },
                          _vm._l(_vm.filteredDevices, function (device) {
                            return _c(
                              "div",
                              {
                                key: device.id,
                                staticClass: "device-card",
                                class: [
                                  `device-${_vm.getDeviceStatusClass(device)}`,
                                  { expanded: _vm.expandedDetails[device.id] },
                                ],
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "device-header",
                                    on: {
                                      click: function ($event) {
                                        return _vm.toggleDetails(device.id)
                                      },
                                    },
                                  },
                                  [
                                    _c("div", {
                                      staticClass: "device-status-indicator",
                                      class: _vm.getDeviceStatusClass(device),
                                    }),
                                    _c("div", { staticClass: "device-title" }, [
                                      _c(
                                        "div",
                                        { staticClass: "device-name-row" },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "device-name" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  device.name || device.mac
                                                )
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "v-btn",
                                            {
                                              staticClass: "edit-name-btn",
                                              attrs: {
                                                icon: "",
                                                "x-small": "",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  $event.stopPropagation()
                                                  return _vm.openEditNameDialog(
                                                    device
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                { attrs: { "x-small": "" } },
                                                [_vm._v("mdi-pencil")]
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-chip",
                                            {
                                              staticClass: "status-chip ml-2",
                                              attrs: {
                                                "x-small": "",
                                                color:
                                                  _vm.getDeviceStatusChipColor(
                                                    device
                                                  ),
                                                dark: "",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.formatStatus(
                                                      device.deviceStatus
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "span",
                                        { staticClass: "device-model" },
                                        [_vm._v(_vm._s(device.modelName))]
                                      ),
                                      device.lastReportTime
                                        ? _c(
                                            "span",
                                            {
                                              staticClass: "staleness-badge",
                                              class: _vm.getStalenessLevel(
                                                device.lastReportTime
                                              ),
                                              attrs: {
                                                title: _vm.formatTimestamp(
                                                  device.lastReportTime
                                                ),
                                              },
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  attrs: {
                                                    "x-small": "",
                                                    color:
                                                      _vm.getStalenessColor(
                                                        device.lastReportTime
                                                      ),
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.getStalenessIcon(
                                                        device.lastReportTime
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "span",
                                                {
                                                  staticClass: "staleness-text",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.getStalenessText(
                                                        device.lastReportTime
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ]),
                                    _c(
                                      "div",
                                      { staticClass: "header-accounts" },
                                      [
                                        device.accounts &&
                                        device.accounts.length
                                          ? _vm._l(
                                              device.accounts,
                                              function (account, index) {
                                                return _c(
                                                  "v-chip",
                                                  {
                                                    key:
                                                      account.accountId ||
                                                      index,
                                                    staticClass: "account-chip",
                                                    attrs: {
                                                      "x-small": "",
                                                      color:
                                                        _vm.getAccountStatusColor(
                                                          account.status
                                                        ),
                                                      dark: "",
                                                      title:
                                                        _vm.getAccountStatusText(
                                                          account.status
                                                        ),
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "v-icon",
                                                      {
                                                        attrs: {
                                                          "x-small": "",
                                                          left: "",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.getAccountStatusIcon(
                                                              account.status
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "account-chip-text",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            account.username ||
                                                              _vm.$t(
                                                                "yealink-line"
                                                              ) +
                                                                " " +
                                                                account.lineId
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                )
                                              }
                                            )
                                          : _c(
                                              "v-chip",
                                              {
                                                staticClass: "account-chip",
                                                attrs: {
                                                  "x-small": "",
                                                  color: "error",
                                                  dark: "",
                                                },
                                              },
                                              [
                                                _c(
                                                  "v-icon",
                                                  {
                                                    attrs: {
                                                      "x-small": "",
                                                      left: "",
                                                    },
                                                  },
                                                  [_vm._v("mdi-account-off")]
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "account-chip-text",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "yealink-no-accounts-short"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                      ],
                                      2
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "device-net",
                                        attrs: {
                                          title: _vm.networkTooltip(device),
                                        },
                                      },
                                      [
                                        _vm.networkScanning ||
                                        !_vm.networkByDevice[device.id]
                                          ? [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "net-chip net-chip-loading",
                                                },
                                                [
                                                  _c("v-progress-circular", {
                                                    attrs: {
                                                      indeterminate: "",
                                                      size: "9",
                                                      width: "2",
                                                      color: "#00acc1",
                                                    },
                                                  }),
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "yealink-net-device-chip-scanning"
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                ],
                                                1
                                              ),
                                            ]
                                          : _vm.networkByDevice[device.id]
                                              .state === "ok"
                                          ? [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "net-chip net-chip-transport",
                                                  style: {
                                                    "--chip-color":
                                                      _vm.networkTransportColor(
                                                        _vm.networkByDevice[
                                                          device.id
                                                        ].transport
                                                      ),
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      attrs: { "x-small": "" },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.networkTransportIcon(
                                                            _vm.networkByDevice[
                                                              device.id
                                                            ].transport
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.networkTransportLabel(
                                                          _vm.networkByDevice[
                                                            device.id
                                                          ].transport
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "net-chip net-chip-stun",
                                                  class: _vm.networkStunClass(
                                                    _vm.networkByDevice[
                                                      device.id
                                                    ]
                                                  ),
                                                },
                                                [
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      attrs: { "x-small": "" },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.networkByDevice[
                                                            device.id
                                                          ].stun === true
                                                            ? "mdi-shield-check"
                                                            : _vm
                                                                .networkByDevice[
                                                                device.id
                                                              ].stun === "mixed"
                                                            ? "mdi-shield-alert"
                                                            : "mdi-shield-off-outline"
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.networkStunLabel(
                                                          _vm.networkByDevice[
                                                            device.id
                                                          ]
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                  _vm.networkByDevice[device.id]
                                                    .stunMisconfigured
                                                    ? _c(
                                                        "v-icon",
                                                        {
                                                          staticClass: "ml-1",
                                                          attrs: {
                                                            "x-small": "",
                                                            color: "#f59e0b",
                                                          },
                                                        },
                                                        [_vm._v("mdi-alert")]
                                                      )
                                                    : _vm._e(),
                                                ],
                                                1
                                              ),
                                            ]
                                          : _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "net-chip net-chip-unknown",
                                                class: `state-${
                                                  _vm.networkByDevice[device.id]
                                                    .state
                                                }`,
                                              },
                                              [
                                                _c(
                                                  "v-icon",
                                                  { attrs: { "x-small": "" } },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.networkByDevice[
                                                          device.id
                                                        ].state === "offline"
                                                          ? "mdi-power-plug-off"
                                                          : "mdi-alert-circle-outline"
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.networkByDevice[
                                                        device.id
                                                      ].state === "offline"
                                                        ? _vm.$t(
                                                            "yealink-net-offline"
                                                          )
                                                        : _vm.$t(
                                                            "yealink-net-error-short"
                                                          )
                                                    ) +
                                                    " "
                                                ),
                                              ],
                                              1
                                            ),
                                      ],
                                      2
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "device-actions" },
                                      [
                                        _c(
                                          "v-tooltip",
                                          {
                                            attrs: { bottom: "" },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "activator",
                                                  fn: function ({ on, attrs }) {
                                                    return [
                                                      _c(
                                                        "v-btn",
                                                        _vm._g(
                                                          _vm._b(
                                                            {
                                                              staticClass:
                                                                "action-icon action-configure",
                                                              attrs: {
                                                                icon: "",
                                                                "x-small": "",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    $event.stopPropagation()
                                                                    return _vm.$emit(
                                                                      "configure-device",
                                                                      device.mac
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            "v-btn",
                                                            attrs,
                                                            false
                                                          ),
                                                          on
                                                        ),
                                                        [
                                                          _c(
                                                            "v-icon",
                                                            {
                                                              attrs: {
                                                                "x-small": "",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "mdi-file-cog"
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "yealink-configure-device"
                                                  )
                                                )
                                              ),
                                            ]),
                                          ]
                                        ),
                                        _c(
                                          "v-tooltip",
                                          {
                                            attrs: { bottom: "" },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "activator",
                                                  fn: function ({ on, attrs }) {
                                                    return [
                                                      _c(
                                                        "v-btn",
                                                        _vm._g(
                                                          _vm._b(
                                                            {
                                                              staticClass:
                                                                "action-icon action-reboot",
                                                              attrs: {
                                                                icon: "",
                                                                "x-small": "",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    $event.stopPropagation()
                                                                    return _vm.openRebootDialog(
                                                                      device
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            "v-btn",
                                                            attrs,
                                                            false
                                                          ),
                                                          on
                                                        ),
                                                        [
                                                          _c(
                                                            "v-icon",
                                                            {
                                                              attrs: {
                                                                "x-small": "",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "mdi-restart"
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(_vm.$t("yealink-reboot"))
                                              ),
                                            ]),
                                          ]
                                        ),
                                        _c(
                                          "v-tooltip",
                                          {
                                            attrs: { bottom: "" },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "activator",
                                                  fn: function ({ on, attrs }) {
                                                    return [
                                                      _c(
                                                        "v-btn",
                                                        _vm._g(
                                                          _vm._b(
                                                            {
                                                              staticClass:
                                                                "action-icon action-reset",
                                                              attrs: {
                                                                icon: "",
                                                                "x-small": "",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    $event.stopPropagation()
                                                                    return _vm.openFactoryResetDialog(
                                                                      device
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            "v-btn",
                                                            attrs,
                                                            false
                                                          ),
                                                          on
                                                        ),
                                                        [
                                                          _c(
                                                            "v-icon",
                                                            {
                                                              attrs: {
                                                                "x-small": "",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "mdi-backup-restore"
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "yealink-factory-reset"
                                                  )
                                                )
                                              ),
                                            ]),
                                          ]
                                        ),
                                        _c("span", {
                                          staticClass: "action-separator",
                                        }),
                                        _c(
                                          "v-tooltip",
                                          {
                                            attrs: { bottom: "" },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "activator",
                                                  fn: function ({ on, attrs }) {
                                                    return [
                                                      _c(
                                                        "v-btn",
                                                        _vm._g(
                                                          _vm._b(
                                                            {
                                                              staticClass:
                                                                "action-icon action-capture",
                                                              attrs: {
                                                                icon: "",
                                                                "x-small": "",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    $event.stopPropagation()
                                                                    return _vm.openPacketCaptureDialog(
                                                                      device
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            "v-btn",
                                                            attrs,
                                                            false
                                                          ),
                                                          on
                                                        ),
                                                        [
                                                          _c(
                                                            "v-icon",
                                                            {
                                                              attrs: {
                                                                "x-small": "",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "mdi-network-outline"
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "yealink-packet-capture"
                                                  )
                                                )
                                              ),
                                            ]),
                                          ]
                                        ),
                                        _c(
                                          "v-tooltip",
                                          {
                                            attrs: { bottom: "" },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "activator",
                                                  fn: function ({ on, attrs }) {
                                                    return [
                                                      _c(
                                                        "v-btn",
                                                        _vm._g(
                                                          _vm._b(
                                                            {
                                                              staticClass:
                                                                "action-icon action-export",
                                                              attrs: {
                                                                icon: "",
                                                                "x-small": "",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    $event.stopPropagation()
                                                                    return _vm.exportDeviceConfig(
                                                                      device
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            "v-btn",
                                                            attrs,
                                                            false
                                                          ),
                                                          on
                                                        ),
                                                        [
                                                          _c(
                                                            "v-icon",
                                                            {
                                                              attrs: {
                                                                "x-small": "",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "mdi-file-export-outline"
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "yealink-export-config"
                                                  )
                                                )
                                              ),
                                            ]),
                                          ]
                                        ),
                                        _c(
                                          "v-tooltip",
                                          {
                                            attrs: { bottom: "" },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "activator",
                                                  fn: function ({ on, attrs }) {
                                                    return [
                                                      _c(
                                                        "v-btn",
                                                        _vm._g(
                                                          _vm._b(
                                                            {
                                                              staticClass:
                                                                "action-icon action-copy",
                                                              attrs: {
                                                                icon: "",
                                                                "x-small": "",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    $event.stopPropagation()
                                                                    return _vm.openCopyConfigDialog(
                                                                      device
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            "v-btn",
                                                            attrs,
                                                            false
                                                          ),
                                                          on
                                                        ),
                                                        [
                                                          _c(
                                                            "v-icon",
                                                            {
                                                              attrs: {
                                                                "x-small": "",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "mdi-content-copy"
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("yealink-copy-config")
                                                )
                                              ),
                                            ]),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-btn",
                                      {
                                        staticClass: "expand-btn",
                                        attrs: { icon: "", small: "" },
                                      },
                                      [
                                        _c("v-icon", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.expandedDetails[device.id]
                                                ? "mdi-chevron-up"
                                                : "mdi-chevron-down"
                                            )
                                          ),
                                        ]),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm.expandedDetails[device.id]
                                  ? _c("div", { staticClass: "device-body" }, [
                                      _c("div", { staticClass: "info-grid" }, [
                                        _c(
                                          "div",
                                          { staticClass: "info-item" },
                                          [
                                            _c(
                                              "v-icon",
                                              {
                                                staticClass: "mr-1",
                                                attrs: { "x-small": "" },
                                              },
                                              [_vm._v("mdi-ethernet")]
                                            ),
                                            _c(
                                              "span",
                                              { staticClass: "info-label" },
                                              [_vm._v("MAC:")]
                                            ),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "info-value monospace",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.formatMac(device.mac)
                                                  )
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "v-btn",
                                              {
                                                staticClass: "copy-btn",
                                                attrs: {
                                                  icon: "",
                                                  "x-small": "",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.copyToClipboard(
                                                      device.mac
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "v-icon",
                                                  { attrs: { "x-small": "" } },
                                                  [_vm._v("mdi-content-copy")]
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "info-item" },
                                          [
                                            _c(
                                              "v-icon",
                                              {
                                                staticClass: "mr-1",
                                                attrs: { "x-small": "" },
                                              },
                                              [_vm._v("mdi-barcode")]
                                            ),
                                            _c(
                                              "span",
                                              { staticClass: "info-label" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("yealink-serial")
                                                  ) + ":"
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "info-value monospace",
                                              },
                                              [_vm._v(_vm._s(device.sn))]
                                            ),
                                            _c(
                                              "v-btn",
                                              {
                                                staticClass: "copy-btn",
                                                attrs: {
                                                  icon: "",
                                                  "x-small": "",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.copyToClipboard(
                                                      device.sn
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "v-icon",
                                                  { attrs: { "x-small": "" } },
                                                  [_vm._v("mdi-content-copy")]
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        device.lanIp
                                          ? _c(
                                              "div",
                                              { staticClass: "info-item" },
                                              [
                                                _c(
                                                  "v-icon",
                                                  {
                                                    staticClass: "mr-1",
                                                    attrs: { "x-small": "" },
                                                  },
                                                  [_vm._v("mdi-ip-network")]
                                                ),
                                                _c(
                                                  "span",
                                                  { staticClass: "info-label" },
                                                  [_vm._v("LAN IP:")]
                                                ),
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "info-value monospace ip-link",
                                                    attrs: {
                                                      href: `https://${device.lanIp}`,
                                                      target: "_blank",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        $event.stopPropagation()
                                                      },
                                                    },
                                                  },
                                                  [_vm._v(_vm._s(device.lanIp))]
                                                ),
                                                _c(
                                                  "v-btn",
                                                  {
                                                    staticClass: "copy-btn",
                                                    attrs: {
                                                      icon: "",
                                                      "x-small": "",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        $event.stopPropagation()
                                                        return _vm.copyToClipboard(
                                                          device.lanIp
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "v-icon",
                                                      {
                                                        attrs: {
                                                          "x-small": "",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "mdi-content-copy"
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        device.wanIp
                                          ? _c(
                                              "div",
                                              { staticClass: "info-item" },
                                              [
                                                _c(
                                                  "v-icon",
                                                  {
                                                    staticClass: "mr-1",
                                                    attrs: { "x-small": "" },
                                                  },
                                                  [_vm._v("mdi-wan")]
                                                ),
                                                _c(
                                                  "span",
                                                  { staticClass: "info-label" },
                                                  [_vm._v("WAN IP:")]
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "info-value monospace",
                                                  },
                                                  [_vm._v(_vm._s(device.wanIp))]
                                                ),
                                                _c(
                                                  "v-btn",
                                                  {
                                                    staticClass: "copy-btn",
                                                    attrs: {
                                                      icon: "",
                                                      "x-small": "",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        $event.stopPropagation()
                                                        return _vm.copyToClipboard(
                                                          device.wanIp
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "v-icon",
                                                      {
                                                        attrs: {
                                                          "x-small": "",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "mdi-content-copy"
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _c(
                                          "div",
                                          { staticClass: "info-item" },
                                          [
                                            _c(
                                              "v-icon",
                                              {
                                                staticClass: "mr-1",
                                                attrs: { "x-small": "" },
                                              },
                                              [
                                                _vm._v(
                                                  "mdi-cellphone-arrow-down"
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "span",
                                              { staticClass: "info-label" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("yealink-firmware")
                                                  ) + ":"
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "span",
                                              { staticClass: "info-value" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    device.programVersion || "-"
                                                  )
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        device.lastReportTime
                                          ? _c(
                                              "div",
                                              { staticClass: "info-item" },
                                              [
                                                _c(
                                                  "v-icon",
                                                  {
                                                    staticClass: "mr-1",
                                                    attrs: { "x-small": "" },
                                                  },
                                                  [_vm._v("mdi-clock-outline")]
                                                ),
                                                _c(
                                                  "span",
                                                  { staticClass: "info-label" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "yealink-last-report"
                                                        )
                                                      ) + ":"
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "span",
                                                  { staticClass: "info-value" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.formatTimestamp(
                                                          device.lastReportTime
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ]),
                                      _vm.networkByDevice[device.id] &&
                                      _vm.networkByDevice[device.id].state ===
                                        "ok" &&
                                      !_vm.networkScanning
                                        ? _c(
                                            "div",
                                            { staticClass: "network-section" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "accounts-header",
                                                },
                                                [
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      staticClass: "mr-1",
                                                      attrs: { "x-small": "" },
                                                    },
                                                    [_vm._v("mdi-lan")]
                                                  ),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "accounts-title",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "yealink-net-title"
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "network-scanned-at",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.formatTimestamp(
                                                            _vm.networkByDevice[
                                                              device.id
                                                            ].scannedAt
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "div",
                                                { staticClass: "network-grid" },
                                                [
                                                  _vm._l(
                                                    _vm.networkByDevice[
                                                      device.id
                                                    ].accounts,
                                                    function (acc) {
                                                      return _c(
                                                        "div",
                                                        {
                                                          key: acc.index,
                                                          staticClass:
                                                            "network-account",
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "line-number",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "yealink-net-account",
                                                                    {
                                                                      index:
                                                                        acc.index,
                                                                    }
                                                                  )
                                                                )
                                                              ),
                                                              acc.username
                                                                ? [
                                                                    _vm._v(
                                                                      " · "
                                                                    ),
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "monospace",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            acc.username
                                                                          )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                : _vm._e(),
                                                            ],
                                                            2
                                                          ),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "net-chip net-chip-transport",
                                                              style: {
                                                                "--chip-color":
                                                                  _vm.networkTransportColor(
                                                                    acc.transport
                                                                  ),
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.networkTransportLabel(
                                                                    acc.transport
                                                                  )
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "detail-label",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "yealink-net-nat"
                                                                  )
                                                                ) + ":"
                                                              ),
                                                            ]
                                                          ),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "detail-value",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.networkNatLabel(
                                                                    acc.natTraversal
                                                                  )
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "detail-label",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "yealink-net-port"
                                                                  )
                                                                ) + ":"
                                                              ),
                                                            ]
                                                          ),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "detail-value monospace",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  acc.port ||
                                                                    "5060"
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "network-account network-global",
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "line-number",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "yealink-net-global-stun"
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "net-chip net-chip-stun",
                                                          class:
                                                            _vm.networkByDevice[
                                                              device.id
                                                            ]
                                                              .stunGlobalEnabled ===
                                                            null
                                                              ? "stun-default"
                                                              : _vm
                                                                  .networkByDevice[
                                                                  device.id
                                                                ]
                                                                  .stunGlobalEnabled
                                                              ? "stun-on"
                                                              : "stun-off",
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm
                                                                  .networkByDevice[
                                                                  device.id
                                                                ]
                                                                  .stunGlobalEnabled ===
                                                                  null
                                                                  ? _vm.$t(
                                                                      "yealink-net-stun-not-exported"
                                                                    )
                                                                  : _vm
                                                                      .networkByDevice[
                                                                      device.id
                                                                    ]
                                                                      .stunGlobalEnabled
                                                                  ? _vm.$t(
                                                                      "yealink-net-stun-on"
                                                                    )
                                                                  : _vm.$t(
                                                                      "yealink-net-stun-off"
                                                                    )
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "detail-value monospace",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm
                                                                .networkByDevice[
                                                                device.id
                                                              ].stunServer ||
                                                                "—"
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                      _vm.networkByDevice[
                                                        device.id
                                                      ].stunMisconfigured
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "network-warn",
                                                            },
                                                            [
                                                              _c(
                                                                "v-icon",
                                                                {
                                                                  staticClass:
                                                                    "mr-1",
                                                                  attrs: {
                                                                    "x-small":
                                                                      "",
                                                                    color:
                                                                      "#f59e0b",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "mdi-alert"
                                                                  ),
                                                                ]
                                                              ),
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "yealink-net-misconfigured"
                                                                  )
                                                                ) + " "
                                                              ),
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e(),
                                                    ]
                                                  ),
                                                ],
                                                2
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _c(
                                        "div",
                                        { staticClass: "accounts-section" },
                                        [
                                          !device.accounts ||
                                          !device.accounts.length
                                            ? _c(
                                                "v-alert",
                                                {
                                                  staticClass: "mb-0",
                                                  attrs: {
                                                    type: "error",
                                                    outlined: "",
                                                    dense: "",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      attrs: {
                                                        small: "",
                                                        left: "",
                                                      },
                                                    },
                                                    [_vm._v("mdi-account-off")]
                                                  ),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "yealink-no-accounts"
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ],
                                                1
                                              )
                                            : [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "accounts-header",
                                                  },
                                                  [
                                                    _c(
                                                      "v-icon",
                                                      {
                                                        staticClass: "mr-1",
                                                        attrs: {
                                                          "x-small": "",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "mdi-account-multiple"
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "accounts-title",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "yealink-accounts"
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "v-chip",
                                                      {
                                                        staticClass: "ml-2",
                                                        attrs: {
                                                          "x-small": "",
                                                          color:
                                                            "grey lighten-2",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              device.accounts
                                                                .length
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "accounts-list",
                                                  },
                                                  _vm._l(
                                                    device.accounts,
                                                    function (account, index) {
                                                      return _c(
                                                        "div",
                                                        {
                                                          key:
                                                            account.accountId ||
                                                            index,
                                                          staticClass:
                                                            "account-item",
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "account-line",
                                                            },
                                                            [
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "line-number",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "yealink-line"
                                                                      )
                                                                    ) +
                                                                      " " +
                                                                      _vm._s(
                                                                        account.lineId
                                                                      )
                                                                  ),
                                                                ]
                                                              ),
                                                              _c(
                                                                "v-chip",
                                                                {
                                                                  attrs: {
                                                                    "x-small":
                                                                      "",
                                                                    color:
                                                                      _vm.getAccountStatusColor(
                                                                        account.status
                                                                      ),
                                                                    dark: "",
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "v-icon",
                                                                    {
                                                                      attrs: {
                                                                        "x-small":
                                                                          "",
                                                                        left: "",
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm.getAccountStatusIcon(
                                                                            account.status
                                                                          )
                                                                        )
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        _vm.getAccountStatusText(
                                                                          account.status
                                                                        )
                                                                      ) +
                                                                      " "
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "account-details",
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "account-detail",
                                                                },
                                                                [
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "detail-label",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm.$t(
                                                                            "yealink-username"
                                                                          )
                                                                        ) + ":"
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "detail-value monospace",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          account.username ||
                                                                            "-"
                                                                        )
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              ),
                                                              account.registerName
                                                                ? _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "account-detail",
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "detail-label",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              _vm.$t(
                                                                                "yealink-register-name"
                                                                              )
                                                                            ) +
                                                                              ":"
                                                                          ),
                                                                        ]
                                                                      ),
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "detail-value monospace",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              account.registerName
                                                                            )
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                              account.accountServer
                                                                ? _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "account-detail",
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "detail-label",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              _vm.$t(
                                                                                "yealink-server"
                                                                              )
                                                                            ) +
                                                                              ":"
                                                                          ),
                                                                        ]
                                                                      ),
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "detail-value monospace",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              account.accountServer
                                                                            )
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                            ]
                                                          ),
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  0
                                                ),
                                              ],
                                        ],
                                        2
                                      ),
                                    ])
                                  : _vm._e(),
                              ]
                            )
                          }),
                          0
                        ),
                  ],
                  1
                ),
              ])
            : _c(
                "div",
                { staticClass: "empty-state" },
                [
                  _c(
                    "v-icon",
                    { attrs: { size: "64", color: "grey lighten-1" } },
                    [_vm._v("mdi-phone-voip")]
                  ),
                  _c("span", { staticClass: "empty-text" }, [
                    _vm._v(_vm._s(_vm.$t("yealink-no-data"))),
                  ]),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "primary", outlined: "", small: "" },
                      on: { click: _vm.fetchDevices },
                    },
                    [
                      _c("v-icon", { attrs: { small: "", left: "" } }, [
                        _vm._v("mdi-refresh"),
                      ]),
                      _vm._v(" " + _vm._s(_vm.$t("refresh")) + " "),
                    ],
                    1
                  ),
                ],
                1
              ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: {
            "max-width": "400",
            persistent: "",
            "content-class": "devops-subdialog",
          },
          model: {
            value: _vm.rebootDialog.open,
            callback: function ($$v) {
              _vm.$set(_vm.rebootDialog, "open", $$v)
            },
            expression: "rebootDialog.open",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "warning white--text" },
                [
                  _c(
                    "v-icon",
                    { staticClass: "mr-2", attrs: { color: "white" } },
                    [_vm._v("mdi-restart")]
                  ),
                  _vm._v(" " + _vm._s(_vm.$t("yealink-reboot")) + " "),
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", small: "", dark: "" },
                      on: {
                        click: function ($event) {
                          _vm.rebootDialog.open = false
                        },
                      },
                    },
                    [_c("v-icon", [_vm._v("mdi-close")])],
                    1
                  ),
                ],
                1
              ),
              _c("v-card-text", { staticClass: "pt-4" }, [
                _c("p", [_vm._v(_vm._s(_vm.$t("yealink-reboot-confirm")))]),
                _c("p", { staticClass: "font-weight-bold mb-0" }, [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.rebootDialog.device?.name ||
                          _vm.rebootDialog.device?.mac
                      ) +
                      " "
                  ),
                ]),
              ]),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { text: "" },
                      on: {
                        click: function ($event) {
                          _vm.rebootDialog.open = false
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("cancel")) + " ")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "warning",
                        loading: _vm.rebootDialog.loading,
                      },
                      on: { click: _vm.rebootDevice },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("yealink-reboot")) + " ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: {
            "max-width": "450",
            persistent: "",
            "content-class": "devops-subdialog",
          },
          model: {
            value: _vm.factoryResetDialog.open,
            callback: function ($$v) {
              _vm.$set(_vm.factoryResetDialog, "open", $$v)
            },
            expression: "factoryResetDialog.open",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "error white--text" },
                [
                  _c(
                    "v-icon",
                    { staticClass: "mr-2", attrs: { color: "white" } },
                    [_vm._v("mdi-backup-restore")]
                  ),
                  _vm._v(" " + _vm._s(_vm.$t("yealink-factory-reset")) + " "),
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", small: "", dark: "" },
                      on: { click: _vm.closeFactoryResetDialog },
                    },
                    [_c("v-icon", [_vm._v("mdi-close")])],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-card-text",
                { staticClass: "pt-4" },
                [
                  _c(
                    "v-alert",
                    {
                      staticClass: "mb-3",
                      attrs: { type: "error", outlined: "", dense: "" },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("yealink-factory-reset-warning")) +
                          " "
                      ),
                    ]
                  ),
                  _c("p", [
                    _vm._v(_vm._s(_vm.$t("yealink-factory-reset-confirm"))),
                  ]),
                  _c("p", { staticClass: "font-weight-bold" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.factoryResetDialog.device?.name ||
                            _vm.factoryResetDialog.device?.mac
                        ) +
                        " "
                    ),
                  ]),
                  _c("v-text-field", {
                    staticClass: "mt-2",
                    attrs: {
                      label: _vm.$t("yealink-type-reset-confirm"),
                      outlined: "",
                      dense: "",
                    },
                    model: {
                      value: _vm.factoryResetDialog.confirmation,
                      callback: function ($$v) {
                        _vm.$set(_vm.factoryResetDialog, "confirmation", $$v)
                      },
                      expression: "factoryResetDialog.confirmation",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { text: "" },
                      on: { click: _vm.closeFactoryResetDialog },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("cancel")) + " ")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "error",
                        loading: _vm.factoryResetDialog.loading,
                        disabled:
                          _vm.factoryResetDialog.confirmation !== "RESET",
                      },
                      on: { click: _vm.factoryResetDevice },
                    },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.$t("yealink-factory-reset")) + " "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: {
            "max-width": "500",
            persistent: "",
            "content-class": "devops-subdialog",
          },
          model: {
            value: _vm.packetCaptureDialog.open,
            callback: function ($$v) {
              _vm.$set(_vm.packetCaptureDialog, "open", $$v)
            },
            expression: "packetCaptureDialog.open",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "purple white--text" },
                [
                  _c(
                    "v-icon",
                    { staticClass: "mr-2", attrs: { color: "white" } },
                    [_vm._v("mdi-network-outline")]
                  ),
                  _vm._v(" " + _vm._s(_vm.$t("yealink-packet-capture")) + " "),
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", small: "", dark: "" },
                      on: { click: _vm.closePacketCaptureDialog },
                    },
                    [_c("v-icon", [_vm._v("mdi-close")])],
                    1
                  ),
                ],
                1
              ),
              _c("v-card-text", { staticClass: "pt-4" }, [
                _c("p", { staticClass: "mb-3" }, [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("yealink-packet-capture-description")) +
                      " "
                  ),
                ]),
                _c("p", { staticClass: "font-weight-bold mb-3" }, [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.packetCaptureDialog.device?.name ||
                          _vm.packetCaptureDialog.device?.mac
                      ) +
                      " "
                  ),
                ]),
                _vm.packetCaptureDialog.status
                  ? _c(
                      "div",
                      { staticClass: "capture-status mb-3" },
                      [
                        _c(
                          "v-alert",
                          {
                            attrs: {
                              type:
                                _vm.packetCaptureDialog.status === "success"
                                  ? "success"
                                  : _vm.packetCaptureDialog.status === "failure"
                                  ? "error"
                                  : "info",
                              outlined: "",
                              dense: "",
                            },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "d-flex align-center" },
                              [
                                _vm.packetCaptureDialog.status === "inprogress"
                                  ? _c("v-progress-circular", {
                                      staticClass: "mr-2",
                                      attrs: {
                                        indeterminate: "",
                                        size: "16",
                                        width: "2",
                                      },
                                    })
                                  : _vm._e(),
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.getPacketCaptureStatusText()) +
                                    " "
                                ),
                              ],
                              1
                            ),
                            _vm.packetCaptureDialog.url
                              ? _c(
                                  "div",
                                  { staticClass: "mt-2" },
                                  [
                                    _c(
                                      "v-btn",
                                      {
                                        attrs: {
                                          small: "",
                                          color: "primary",
                                          href: _vm.packetCaptureDialog.url,
                                          target: "_blank",
                                        },
                                      },
                                      [
                                        _c(
                                          "v-icon",
                                          { attrs: { small: "", left: "" } },
                                          [_vm._v("mdi-download")]
                                        ),
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t("yealink-download-capture")
                                            ) +
                                            " "
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { text: "" },
                      on: { click: _vm.closePacketCaptureDialog },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("close")) + " ")]
                  ),
                  !_vm.packetCaptureDialog.status ||
                  _vm.packetCaptureDialog.status === "success" ||
                  _vm.packetCaptureDialog.status === "failure"
                    ? _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "purple",
                            dark: "",
                            loading: _vm.packetCaptureDialog.loading,
                          },
                          on: { click: _vm.startPacketCapture },
                        },
                        [
                          _c("v-icon", { attrs: { left: "", small: "" } }, [
                            _vm._v("mdi-play"),
                          ]),
                          _vm._v(
                            " " + _vm._s(_vm.$t("yealink-start-capture")) + " "
                          ),
                        ],
                        1
                      )
                    : _vm.packetCaptureDialog.status === "inprogress"
                    ? _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "error",
                            loading: _vm.packetCaptureDialog.loading,
                          },
                          on: { click: _vm.stopPacketCapture },
                        },
                        [
                          _c("v-icon", { attrs: { left: "", small: "" } }, [
                            _vm._v("mdi-stop"),
                          ]),
                          _vm._v(
                            " " + _vm._s(_vm.$t("yealink-stop-capture")) + " "
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: {
            "max-width": "500",
            persistent: "",
            "content-class": "devops-subdialog",
          },
          model: {
            value: _vm.copyConfigDialog.open,
            callback: function ($$v) {
              _vm.$set(_vm.copyConfigDialog, "open", $$v)
            },
            expression: "copyConfigDialog.open",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "teal white--text" },
                [
                  _c(
                    "v-icon",
                    { staticClass: "mr-2", attrs: { color: "white" } },
                    [_vm._v("mdi-content-copy")]
                  ),
                  _vm._v(" " + _vm._s(_vm.$t("yealink-copy-config")) + " "),
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", small: "", dark: "" },
                      on: { click: _vm.closeCopyConfigDialog },
                    },
                    [_c("v-icon", [_vm._v("mdi-close")])],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-card-text",
                { staticClass: "pt-4" },
                [
                  _c("p", { staticClass: "mb-3" }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("yealink-copy-config-description")) +
                        " "
                    ),
                  ]),
                  _c("p", { staticClass: "mb-2" }, [
                    _c("strong", [
                      _vm._v(_vm._s(_vm.$t("yealink-target-device")) + ":"),
                    ]),
                  ]),
                  _c("p", { staticClass: "font-weight-bold mb-3 ml-2" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.copyConfigDialog.device?.name ||
                            _vm.copyConfigDialog.device?.mac
                        ) +
                        " "
                    ),
                  ]),
                  _c("v-autocomplete", {
                    attrs: {
                      items: _vm.availableSourceDevices,
                      label: _vm.$t("yealink-source-device"),
                      "item-text": "displayName",
                      "item-value": "id",
                      "return-object": "",
                      outlined: "",
                      dense: "",
                      disabled: _vm.copyConfigDialog.loading,
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "item",
                        fn: function ({ item }) {
                          return [
                            _c(
                              "v-list-item-content",
                              [
                                _c("v-list-item-title", [
                                  _vm._v(_vm._s(item.name || item.mac)),
                                ]),
                                _c("v-list-item-subtitle", [
                                  _vm._v(
                                    _vm._s(item.modelName) +
                                      " - " +
                                      _vm._s(_vm.formatMac(item.mac))
                                  ),
                                ]),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                    model: {
                      value: _vm.copyConfigDialog.sourceDevice,
                      callback: function ($$v) {
                        _vm.$set(_vm.copyConfigDialog, "sourceDevice", $$v)
                      },
                      expression: "copyConfigDialog.sourceDevice",
                    },
                  }),
                  _vm.copyConfigDialog.error
                    ? _c(
                        "v-alert",
                        {
                          staticClass: "mt-2",
                          attrs: { type: "error", outlined: "", dense: "" },
                        },
                        [_vm._v(" " + _vm._s(_vm.copyConfigDialog.error) + " ")]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { text: "" },
                      on: { click: _vm.closeCopyConfigDialog },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("cancel")) + " ")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "teal",
                        dark: "",
                        loading: _vm.copyConfigDialog.loading,
                        disabled: !_vm.copyConfigDialog.sourceDevice,
                      },
                      on: { click: _vm.copyConfig },
                    },
                    [
                      _c("v-icon", { attrs: { left: "", small: "" } }, [
                        _vm._v("mdi-content-copy"),
                      ]),
                      _vm._v(" " + _vm._s(_vm.$t("yealink-copy-config")) + " "),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: {
            "max-width": "450",
            persistent: "",
            "content-class": "devops-subdialog",
          },
          model: {
            value: _vm.exportConfigDialog.open,
            callback: function ($$v) {
              _vm.$set(_vm.exportConfigDialog, "open", $$v)
            },
            expression: "exportConfigDialog.open",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "blue white--text" },
                [
                  _c(
                    "v-icon",
                    { staticClass: "mr-2", attrs: { color: "white" } },
                    [_vm._v("mdi-file-export-outline")]
                  ),
                  _vm._v(" " + _vm._s(_vm.$t("yealink-export-config")) + " "),
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", small: "", dark: "" },
                      on: { click: _vm.closeExportConfigDialog },
                    },
                    [_c("v-icon", [_vm._v("mdi-close")])],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-card-text",
                { staticClass: "pt-4" },
                [
                  _c("p", { staticClass: "mb-3" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.exportConfigDialog.device?.name ||
                            _vm.exportConfigDialog.device?.mac
                        ) +
                        " "
                    ),
                  ]),
                  _c(
                    "v-alert",
                    {
                      attrs: {
                        type:
                          _vm.exportConfigDialog.status === "success"
                            ? "success"
                            : _vm.exportConfigDialog.status === "failure"
                            ? "error"
                            : "info",
                        outlined: "",
                        dense: "",
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "d-flex align-center" },
                        [
                          _vm.exportConfigDialog.status === "inprogress"
                            ? _c("v-progress-circular", {
                                staticClass: "mr-2",
                                attrs: {
                                  indeterminate: "",
                                  size: "16",
                                  width: "2",
                                },
                              })
                            : _vm._e(),
                          _vm._v(" " + _vm._s(_vm.getExportStatusText()) + " "),
                        ],
                        1
                      ),
                      _vm.exportConfigDialog.url
                        ? _c(
                            "div",
                            { staticClass: "mt-2" },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    small: "",
                                    color: "primary",
                                    href: _vm.exportConfigDialog.url,
                                    target: "_blank",
                                  },
                                },
                                [
                                  _c(
                                    "v-icon",
                                    { attrs: { small: "", left: "" } },
                                    [_vm._v("mdi-download")]
                                  ),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("yealink-download-config")
                                      ) +
                                      " "
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { text: "" },
                      on: { click: _vm.closeExportConfigDialog },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("close")) + " ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: {
            "max-width": "500",
            persistent: "",
            fullscreen: _vm.$vuetify.breakpoint.xsOnly,
            "content-class": "devops-subdialog",
          },
          model: {
            value: _vm.addDeviceDialog.open,
            callback: function ($$v) {
              _vm.$set(_vm.addDeviceDialog, "open", $$v)
            },
            expression: "addDeviceDialog.open",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "primary white--text" },
                [
                  _c(
                    "v-icon",
                    { staticClass: "mr-2", attrs: { color: "white" } },
                    [_vm._v("mdi-plus")]
                  ),
                  _vm._v(" " + _vm._s(_vm.$t("yealink-add-device")) + " "),
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", small: "", dark: "" },
                      on: { click: _vm.closeAddDeviceDialog },
                    },
                    [_c("v-icon", [_vm._v("mdi-close")])],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-card-text",
                { staticClass: "pt-4" },
                [
                  _c(
                    "v-form",
                    {
                      ref: "addDeviceForm",
                      model: {
                        value: _vm.addDeviceDialog.valid,
                        callback: function ($$v) {
                          _vm.$set(_vm.addDeviceDialog, "valid", $$v)
                        },
                        expression: "addDeviceDialog.valid",
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "scan-label-wrapper mb-3" },
                        [
                          _c("input", {
                            ref: "labelPhotoInput",
                            staticClass: "d-none",
                            attrs: {
                              type: "file",
                              accept: "image/*,.heic,.heif",
                            },
                            on: { change: _vm.onLabelPhotoSelected },
                          }),
                          _c(
                            "v-btn",
                            {
                              staticClass: "scan-label-btn",
                              attrs: {
                                outlined: "",
                                block: "",
                                loading: _vm.addDeviceDialog.scanLoading,
                                disabled: _vm.addDeviceDialog.loading,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.$refs.labelPhotoInput.click()
                                },
                              },
                            },
                            [
                              _c("v-icon", [_vm._v("mdi-camera")]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("yealink-scan-device-label")) +
                                  " "
                              ),
                            ],
                            1
                          ),
                          _c(
                            "p",
                            {
                              staticClass:
                                "text-caption grey--text mt-1 mb-0 text-center",
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("yealink-scan-label-hint")) +
                                  " "
                              ),
                            ]
                          ),
                          _vm.addDeviceDialog.scanError
                            ? _c(
                                "v-alert",
                                {
                                  staticClass: "mt-2",
                                  attrs: {
                                    type: "warning",
                                    outlined: "",
                                    dense: "",
                                    dismissible: "",
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.addDeviceDialog.scanError) +
                                      " "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c("v-text-field", {
                        staticClass: "mb-2 copy-field",
                        attrs: {
                          label: _vm.$t("yealink-mac-address") + " *",
                          rules: [(v) => !!v || _vm.$t("required")],
                          outlined: "",
                          dense: "",
                          disabled: _vm.addDeviceDialog.loading,
                          placeholder: "001565XXXXXX",
                        },
                        on: {
                          input: function ($event) {
                            _vm.addDeviceDialog.mac = _vm.sanitizeDeviceInput(
                              _vm.addDeviceDialog.mac
                            )
                          },
                        },
                        scopedSlots: _vm._u(
                          [
                            _vm.addDeviceDialog.mac
                              ? {
                                  key: "append-outer",
                                  fn: function () {
                                    return [
                                      _c(
                                        "v-icon",
                                        {
                                          staticClass: "copy-icon",
                                          attrs: { small: "" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.copyToClipboard(
                                                _vm.addDeviceDialog.mac
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("mdi-content-copy")]
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                }
                              : null,
                          ],
                          null,
                          true
                        ),
                        model: {
                          value: _vm.addDeviceDialog.mac,
                          callback: function ($$v) {
                            _vm.$set(_vm.addDeviceDialog, "mac", $$v)
                          },
                          expression: "addDeviceDialog.mac",
                        },
                      }),
                      _c("v-text-field", {
                        staticClass: "mb-2 copy-field",
                        attrs: {
                          label: _vm.$t("yealink-serial-number") + " *",
                          rules: [(v) => !!v || _vm.$t("required")],
                          outlined: "",
                          dense: "",
                          disabled: _vm.addDeviceDialog.loading,
                        },
                        on: {
                          input: function ($event) {
                            _vm.addDeviceDialog.sn = _vm.sanitizeDeviceInput(
                              _vm.addDeviceDialog.sn
                            )
                          },
                        },
                        scopedSlots: _vm._u(
                          [
                            _vm.addDeviceDialog.sn
                              ? {
                                  key: "append-outer",
                                  fn: function () {
                                    return [
                                      _c(
                                        "v-icon",
                                        {
                                          staticClass: "copy-icon",
                                          attrs: { small: "" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.copyToClipboard(
                                                _vm.addDeviceDialog.sn
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("mdi-content-copy")]
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                }
                              : null,
                          ],
                          null,
                          true
                        ),
                        model: {
                          value: _vm.addDeviceDialog.sn,
                          callback: function ($$v) {
                            _vm.$set(_vm.addDeviceDialog, "sn", $$v)
                          },
                          expression: "addDeviceDialog.sn",
                        },
                      }),
                      _c("v-autocomplete", {
                        staticClass: "mb-2",
                        attrs: {
                          items: _vm.deviceModels,
                          "item-text": "name",
                          "item-value": "id",
                          label: _vm.$t("yealink-device-model") + " *",
                          rules: [(v) => !!v || _vm.$t("required")],
                          outlined: "",
                          dense: "",
                          clearable: "",
                          disabled: _vm.addDeviceDialog.loading,
                          loading: _vm.deviceModelsLoading,
                          filter: (item, queryText) =>
                            item.name
                              .toLowerCase()
                              .includes(queryText.toLowerCase()),
                        },
                        model: {
                          value: _vm.addDeviceDialog.modelId,
                          callback: function ($$v) {
                            _vm.$set(_vm.addDeviceDialog, "modelId", $$v)
                          },
                          expression: "addDeviceDialog.modelId",
                        },
                      }),
                      _c("v-text-field", {
                        attrs: {
                          label: _vm.$t("yealink-device-name"),
                          outlined: "",
                          dense: "",
                          disabled: _vm.addDeviceDialog.loading,
                          hint: _vm.$t("optional"),
                          "persistent-hint": "",
                        },
                        model: {
                          value: _vm.addDeviceDialog.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.addDeviceDialog, "name", $$v)
                          },
                          expression: "addDeviceDialog.name",
                        },
                      }),
                      _c("v-checkbox", {
                        staticClass: "mt-0",
                        attrs: {
                          label: _vm.$t("yealink-skip-rps"),
                          disabled: _vm.addDeviceDialog.loading,
                          "hide-details": "",
                        },
                        model: {
                          value: _vm.addDeviceDialog.skipRps,
                          callback: function ($$v) {
                            _vm.$set(_vm.addDeviceDialog, "skipRps", $$v)
                          },
                          expression: "addDeviceDialog.skipRps",
                        },
                      }),
                      _c(
                        "div",
                        { staticClass: "rps-hint mt-3" },
                        [
                          _c(
                            "v-icon",
                            {
                              staticClass: "mr-1",
                              attrs: { small: "", color: "info" },
                            },
                            [_vm._v("mdi-information-outline")]
                          ),
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.$t("yealink-rps-hint-prefix")) + " "
                            ),
                            _c(
                              "a",
                              {
                                staticClass: "rps-link",
                                attrs: {
                                  href: "https://us.ymcs.yealink.com/manager/rps-equipment?platform=RPS",
                                  target: "_blank",
                                  rel: "noopener noreferrer",
                                },
                              },
                              [_vm._v("YMCS RPS")]
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.addDeviceDialog.error
                    ? _c(
                        "v-alert",
                        {
                          staticClass: "mt-3 add-device-error",
                          attrs: { type: "error", outlined: "", dense: "" },
                        },
                        [_vm._v(" " + _vm._s(_vm.addDeviceDialog.error) + " ")]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { text: "" },
                      on: { click: _vm.closeAddDeviceDialog },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("cancel")) + " ")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "primary",
                        loading: _vm.addDeviceDialog.loading,
                        disabled: !_vm.addDeviceDialog.valid,
                      },
                      on: { click: _vm.addDevice },
                    },
                    [
                      _c("v-icon", { attrs: { left: "", small: "" } }, [
                        _vm._v("mdi-plus"),
                      ]),
                      _vm._v(" " + _vm._s(_vm.$t("yealink-add-device")) + " "),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: {
            "max-width": "600",
            persistent: "",
            fullscreen: _vm.$vuetify.breakpoint.xsOnly,
            "content-class": "devops-subdialog",
          },
          model: {
            value: _vm.importDevicesDialog.open,
            callback: function ($$v) {
              _vm.$set(_vm.importDevicesDialog, "open", $$v)
            },
            expression: "importDevicesDialog.open",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "primary white--text" },
                [
                  _c(
                    "v-icon",
                    { staticClass: "mr-2", attrs: { color: "white" } },
                    [_vm._v("mdi-file-upload")]
                  ),
                  _vm._v(" " + _vm._s(_vm.$t("yealink-import-devices")) + " "),
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", small: "", dark: "" },
                      on: { click: _vm.closeImportDevicesDialog },
                    },
                    [_c("v-icon", [_vm._v("mdi-close")])],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-card-text",
                { staticClass: "pt-4" },
                [
                  _c(
                    "v-alert",
                    {
                      staticClass: "mb-3",
                      attrs: { type: "info", outlined: "", dense: "" },
                    },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.$t("yealink-import-file-hint")) + " "
                      ),
                    ]
                  ),
                  _c("v-file-input", {
                    attrs: {
                      label: _vm.$t("yealink-import-select-file"),
                      accept: ".xlsx,.xls",
                      outlined: "",
                      dense: "",
                      "prepend-icon": "mdi-microsoft-excel",
                      disabled: _vm.importDevicesDialog.loading,
                      "show-size": "",
                    },
                    model: {
                      value: _vm.importDevicesDialog.file,
                      callback: function ($$v) {
                        _vm.$set(_vm.importDevicesDialog, "file", $$v)
                      },
                      expression: "importDevicesDialog.file",
                    },
                  }),
                  _vm.importDevicesDialog.results
                    ? _c(
                        "div",
                        { staticClass: "mt-4" },
                        [
                          _vm.importDevicesDialog.results.added > 0
                            ? _c(
                                "v-alert",
                                {
                                  attrs: {
                                    type: "success",
                                    outlined: "",
                                    dense: "",
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("yealink-import-success", {
                                          count:
                                            _vm.importDevicesDialog.results
                                              .added,
                                          total:
                                            _vm.importDevicesDialog.results
                                              .total,
                                        })
                                      ) +
                                      " "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm.importDevicesDialog.results.failed > 0
                            ? _c(
                                "v-alert",
                                {
                                  attrs: {
                                    type: "warning",
                                    outlined: "",
                                    dense: "",
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("yealink-import-failures", {
                                          count:
                                            _vm.importDevicesDialog.results
                                              .failed,
                                        })
                                      ) +
                                      " "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm.importDevicesDialog.results.results.failed.length
                            ? _c(
                                "v-simple-table",
                                { staticClass: "mt-2", attrs: { dense: "" } },
                                [
                                  _c("thead", [
                                    _c("tr", [
                                      _c("th", [_vm._v("SKU")]),
                                      _c("th", [_vm._v("MAC")]),
                                      _c("th", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("yealink-serial-number")
                                          )
                                        ),
                                      ]),
                                      _c("th", [
                                        _vm._v(
                                          _vm._s(_vm.$t("yealink-import-error"))
                                        ),
                                      ]),
                                    ]),
                                  ]),
                                  _c(
                                    "tbody",
                                    _vm._l(
                                      _vm.importDevicesDialog.results.results
                                        .failed,
                                      function (item, i) {
                                        return _c("tr", { key: i }, [
                                          _c("td", [_vm._v(_vm._s(item.sku))]),
                                          _c("td", [_vm._v(_vm._s(item.mac))]),
                                          _c("td", [_vm._v(_vm._s(item.sn))]),
                                          _c(
                                            "td",
                                            { staticClass: "error--text" },
                                            [
                                              _vm._v(
                                                " " + _vm._s(item.error) + " "
                                              ),
                                            ]
                                          ),
                                        ])
                                      }
                                    ),
                                    0
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { text: "" },
                      on: { click: _vm.closeImportDevicesDialog },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.importDevicesDialog.results
                              ? _vm.$t("close")
                              : _vm.$t("cancel")
                          ) +
                          " "
                      ),
                    ]
                  ),
                  !_vm.importDevicesDialog.results
                    ? _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "primary",
                            loading: _vm.importDevicesDialog.loading,
                            disabled: !_vm.importDevicesDialog.file,
                          },
                          on: { click: _vm.importDevices },
                        },
                        [
                          _c("v-icon", { attrs: { left: "", small: "" } }, [
                            _vm._v("mdi-upload"),
                          ]),
                          _vm._v(
                            " " + _vm._s(_vm.$t("yealink-import-devices")) + " "
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: {
            "max-width": "400",
            persistent: "",
            "content-class": "devops-subdialog",
          },
          model: {
            value: _vm.editNameDialog.open,
            callback: function ($$v) {
              _vm.$set(_vm.editNameDialog, "open", $$v)
            },
            expression: "editNameDialog.open",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "primary white--text" },
                [
                  _c(
                    "v-icon",
                    { staticClass: "mr-2", attrs: { color: "white" } },
                    [_vm._v("mdi-pencil")]
                  ),
                  _vm._v(" " + _vm._s(_vm.$t("yealink-edit-name")) + " "),
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", small: "", dark: "" },
                      on: { click: _vm.closeEditNameDialog },
                    },
                    [_c("v-icon", [_vm._v("mdi-close")])],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-card-text",
                { staticClass: "pt-4" },
                [
                  _c("v-text-field", {
                    attrs: {
                      label: _vm.$t("yealink-device-name"),
                      outlined: "",
                      dense: "",
                      disabled: _vm.editNameDialog.loading,
                      autofocus: "",
                    },
                    on: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.saveDeviceName.apply(null, arguments)
                      },
                    },
                    model: {
                      value: _vm.editNameDialog.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.editNameDialog, "name", $$v)
                      },
                      expression: "editNameDialog.name",
                    },
                  }),
                  _vm.editNameDialog.error
                    ? _c(
                        "v-alert",
                        {
                          staticClass: "mt-2 mb-0 error-alert",
                          attrs: { type: "error", outlined: "", dense: "" },
                        },
                        [_vm._v(" " + _vm._s(_vm.editNameDialog.error) + " ")]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { text: "" },
                      on: { click: _vm.closeEditNameDialog },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("cancel")) + " ")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "primary",
                        loading: _vm.editNameDialog.loading,
                      },
                      on: { click: _vm.saveDeviceName },
                    },
                    [
                      _c("v-icon", { attrs: { left: "", small: "" } }, [
                        _vm._v("mdi-content-save"),
                      ]),
                      _vm._v(" " + _vm._s(_vm.$t("save")) + " "),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: {
            "max-width": "500",
            persistent: "",
            "content-class": "devops-subdialog",
          },
          model: {
            value: _vm.siteSelectionDialog.open,
            callback: function ($$v) {
              _vm.$set(_vm.siteSelectionDialog, "open", $$v)
            },
            expression: "siteSelectionDialog.open",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "primary white--text" },
                [
                  _c(
                    "v-icon",
                    { staticClass: "mr-2", attrs: { color: "white" } },
                    [_vm._v("mdi-domain")]
                  ),
                  _vm._v(" " + _vm._s(_vm.$t("yealink-change-site")) + " "),
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", small: "", dark: "" },
                      on: { click: _vm.closeSiteSelectionDialog },
                    },
                    [_c("v-icon", [_vm._v("mdi-close")])],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-card-text",
                { staticClass: "pt-4" },
                [
                  _c("v-autocomplete", {
                    ref: "siteAutocomplete",
                    attrs: {
                      items: _vm.sites,
                      loading: _vm.sitesLoading,
                      "search-input": _vm.siteSearchQuery,
                      filter: _vm.siteFilter,
                      "item-text": "name",
                      "item-value": "id",
                      label: _vm.$t("yealink-select-site"),
                      placeholder: _vm.$t("yealink-search-site-placeholder"),
                      outlined: "",
                      "hide-details": "",
                      clearable: "",
                      "return-object": "",
                      "prepend-inner-icon": "mdi-magnify",
                      "auto-select-first": "",
                    },
                    on: {
                      "update:searchInput": function ($event) {
                        _vm.siteSearchQuery = $event
                      },
                      "update:search-input": function ($event) {
                        _vm.siteSearchQuery = $event
                      },
                      change: _vm.onSiteAutocompleteChange,
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "item",
                        fn: function ({ item }) {
                          return [
                            _c(
                              "v-list-item-content",
                              [
                                _c("v-list-item-title", [
                                  _vm._v(_vm._s(item.name)),
                                ]),
                                _c(
                                  "v-list-item-subtitle",
                                  { staticClass: "text-caption" },
                                  [_vm._v(" ID: " + _vm._s(item.id) + " ")]
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                      {
                        key: "selection",
                        fn: function ({ item }) {
                          return [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "text-truncate site-selection-text",
                              },
                              [_vm._v(_vm._s(item.name))]
                            ),
                          ]
                        },
                      },
                    ]),
                    model: {
                      value: _vm.siteSelectionDialog.selectedSite,
                      callback: function ($$v) {
                        _vm.$set(_vm.siteSelectionDialog, "selectedSite", $$v)
                      },
                      expression: "siteSelectionDialog.selectedSite",
                    },
                  }),
                  _c(
                    "p",
                    { staticClass: "text-caption grey--text mt-2 mb-0" },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("yealink-site-selection-hint")) +
                          " "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { text: "" },
                      on: { click: _vm.closeSiteSelectionDialog },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("cancel")) + " ")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "primary" },
                      on: { click: _vm.confirmSiteSelection },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("confirm")) + " ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { attrs: { id: "label-scanner-tmp" } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }